import React from 'react';
import SimpleHero from '../components/SimpleHero/SimpleHero';
import PageHero from '../components/Minimal/PageHero';
import FeatureList from '../components/Minimal/FeatureList';
import hidden from "../assets/images/hidden.png";
import hidden3 from "../assets/images/mobile-banking.png";
import hiddens from "../assets/images/piggy-bank.png";
import personalBankingImg from "../assets/images/PersonalBanking.jpg";
import { CUSTOMER_PORTAL_URL } from '../constants/links';

const BusinessChecking = () => {
  return (
    <div>
      <SimpleHero
        title="Everyday banking for your business"
        subtitle="Simple fees, easy payments, and tools to keep your cash flowing."
        primaryLabel="Open an account"
        primaryHref={CUSTOMER_PORTAL_URL}
        variant="sofi"
        imageSrc={personalBankingImg}
        imageAlt="Business checking preview"
        imageOn="right"
        tiltImage
        badges={["No monthly fees","Mobile & Online","FDIC insured"]}
      />
      <FeatureList
        items={[
          { icon: hidden, title: 'No monthly fees', desc: 'Straightforward pricing for your business.' },
          { icon: hidden3, title: 'Mobile banking', desc: 'Pay vendors and move money on the go.' },
          { icon: hiddens, title: 'FDIC insured', desc: 'Coverage up to $250,000.' },
        ]}
      />
    </div>
  );
};

export default BusinessChecking;